<div class="footer secondaryBackground">
  <div class="footer-row">
    <!-- Logo Section -->
    <div class="footer-links banner">
      <div class="simple-banner banner__component--responsive">
        <img
          class="js-responsive-image"
          alt="Andes Motor"
          title="Andes Motor"
          src="/assets/img/footerLogo-andesmotorlogo.svg"
        />
      </div>
    </div>
    <!-- Contact Info Section -->
    <div class="footer-links contact-info footer-title">
      <div class="title-footer">
        <h3 style="font-size: 18px !important">Contáctanos</h3>
        <p style="margin-top: 20px; margin-bottom: 0">
          Siempre estamos abiertos a cooperación y sugerencias, contáctanos:
        </p>
      </div>
      <div class="datos-col-1">
        <div class="dato-footer">
          <small>Numero de teléfono</small>
          <div class="dato-val" style="margin-top: 8px">
            <a href="tel:+56956383089" style="color: #ffffff; font-family: Roboto !important; font-size: 16px; cursor: pointer">+569 5638 30 89</a>
          </div>
        </div>
        <div class="dato-footer" style="margin-top: 15px">
          <small>Correo electrónico</small>
          <div class="dato-val" style="margin-top: 8px">
            <a href="mailto:repuestos@andesmotor.cl" style="color: #ffffff; font-family: Roboto !important; font-size: 16px; cursor: pointer">repuestos&#64;andesmotor.cl</a>
          </div>
        </div>
      </div>
      <div class="datos-col-2">
        <div class="dato-footer">
          <small>Ubicación</small>
          <div class="dato-val" style="margin-top: 8px">
            <a href="https://maps.google.com/?q=Am%C3%A9rico+Vespucio+760,+Pudahuel" target="_blank" rel="noopener noreferrer" style="color: #ffffff; font-family: Roboto !important; font-size: 16px; cursor: pointer">Américo Vespucio #760, Pudahuel.</a>
          </div>
        </div>
        <div class="dato-footer" style="margin-top: 15px">
          <small>Horarios de antencion</small>
          <div class="dato-val" style="margin-top: 8px; color: #ffffff; font-family: Roboto !important; font-size: 16px;">
            Lun a Vie 09:00 a 17:30 hrs.
          </div>
        </div>
      </div>
    </div>
    <!-- Information Links Section -->
    <div>
      <div class="footer-links menus info">
        <h3 class="font-weight-bold pb-1 footer-title">Información</h3>
        <ul class="list-unstyled">
          <li class="pb-2">
            <button type="button" (click)="scrollToTop()" #open class="btn-link-custom text-white footer-text footer-subtitle">
              Términos y condiciones
            </button>
          </li>
          <li>
            <button type="button" (click)="scrollToTop()" class="btn-link-custom text-white footer-text footer-subtitle">
              Preguntas frecuentes
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!-- Account Links Section -->
    <div *ngIf="isUserlogged$ | async; else notLoggedIn" class="footer-links menus account">
      <h3 class="font-weight-bold footer-title">Mi cuenta</h3>
      <ul class="list-unstyled">
        <li><a (click)="logout()" class="text-white" style="cursor: pointer">Cerrar sesión</a></li>
      </ul>
    </div>

    <ng-template #notLoggedIn>
      <div class="footer-links menus account">
        <h3 class="font-weight-bold footer-title">Mi cuenta</h3>
        <ul class="list-unstyled">
          <li><a [routerLink]="{ cxRoute: 'login' } | cxUrl" class="text-white footer-subtitle">Iniciar sesión</a></li>
        </ul>
      </div>
    </ng-template>
  </div>
</div>

<div class="row text-center justify-content-center">
  <div class="col-12">
    <p class="copyRights mb-0">
      &#169; {{ currentYear }} Andes Motor. Todos los derechos reservados. Am&eacute;rico Vespucio #760, Pudahuel.
    </p>
  </div>
</div>

<cx-scroll-to-top></cx-scroll-to-top>
